/**
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the Commercial License found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var getDropRowIndex = function getDropRowIndex(_ref) {
  var rowHeightManager = _ref.rowHeightManager,
    dragBoxInitialRegion = _ref.dragBoxInitialRegion,
    dragBoxOffsets = _ref.dragBoxOffsets,
    initialDiffTop = _ref.initialDiffTop,
    scrollTop = _ref.scrollTop,
    dragIndex = _ref.dragIndex,
    dir = _ref.dir;
  var rowOffset = dragBoxInitialRegion.top - dragBoxOffsets.top + initialDiffTop + scrollTop;
  var currentIndex = rowHeightManager.getRowAt(rowOffset);
  if (currentIndex < 0) {
    return {
      index: -1
    };
  }
  var nextRowIndex = currentIndex + dir;
  var nextRowHeight = rowHeightManager.getRowHeight(nextRowIndex);
  var nextRowOffset = rowHeightManager.getRowOffset(nextRowIndex);
  var halfSize = nextRowHeight / 2;
  if (nextRowOffset < 0) {
    nextRowOffset = 0;
  }
  var newDropIndex = -1;
  if (dir > 0) {
    if (rowOffset >= nextRowOffset - halfSize) {
      newDropIndex = nextRowIndex;
    }
  }
  if (dir < 0) {
    if (rowOffset > nextRowOffset + halfSize + nextRowHeight) {
      newDropIndex = currentIndex === dragIndex ? dragIndex : currentIndex + 1;
    } else {
      newDropIndex = currentIndex;
    }
  }
  if (newDropIndex === -1) {
    newDropIndex = currentIndex;
  }
  return {
    index: newDropIndex
  };
};
var _default = getDropRowIndex;
exports.default = _default;